import { render } from "./FlexCenter.vue?vue&type=template&id=46f9e682"
const script = {}
script.render = render

export default script